"use client";

import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectGroup,
} from "@/shared/components/common/Select";
import data from "@/public/data/hotel/hotel.roomCounter.json";
import config from "@/configs/config";

interface IAgeSelect {
  onClick?: (input: string) => void;
  selectedAge: string;
}

export default function AgeSelect({ onClick, selectedAge }: IAgeSelect) {
  const { childAge } = data;

  return (
    <Select
      dir={config.dir}
      onValueChange={onClick}
      value={selectedAge || ""}
    >
      <SelectTrigger className="w-full rounded-xs">
        <SelectValue placeholder={childAge.title} />
      </SelectTrigger>
      <SelectContent className="rounded-xs">
        <SelectGroup>
          {Array(12)
            .fill("")
            .map((_, i) => (
              <SelectItem
                key={i}
                value={String(i + 1)}
                className="rounded-none!"
              >
                {i + 1} {childAge.selectItempostfix}
              </SelectItem>
            ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
